import { StaticImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie-player';

export default function HomeLottie() {
  const [animationData, setAnimationData] = useState();

  useEffect(() => {
    setTimeout(() => {
      import('~/assets/images/homepageMasthead.json').then(setAnimationData);
    }, 5000);
  }, []);

  if (!animationData) return <StaticImage src={`../../assets/images/hero.png`} placeholder="none" alt="hero" />;
  return <Lottie loop animationData={animationData} play />
}
